import { Component, ViewChild, HostListener, ChangeDetectorRef, AfterViewChecked } from '@angular/core';
import { AuthenticationService } from '@wephone-core/service/authentication';
import { AgentEntity } from '@wephone-core/model/entity/agent';
import { MessageService, DialogService, Platform } from '@wephone-utils';
import { MyCallCenterStatusRepository } from '@wephone-core/model/repository/my_callcenter_status';
import { MyCallCenterStatus } from '@wephone-core/model/entity/my_callcenter_status';
import { KeypadComponent } from '@wephone-app-phone/components/keypad/keypad';
import { PhoneService } from '../../services/phone/phone.service';
import { UserEntity } from '@wephone-core/model/entity/user';
import { AgentPanelComponent } from '@wephone-app-phone/components/agent-panel/agent-panel';
import { FlexBasePage } from '@wephone-core-ui';
import { PauseAgentDialog } from '@wephone-common/modals';
import { AgentPanelService } from '@wephone/services/agent-panel.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheetChangeVolume } from '@wephone-app-phone/modals/settings/bottom-sheet-change-volume/bottom-sheet-change-volume.component';
import { AgentService } from '@wephone/services/agent.service';
import { _ti } from '@wephone-translation';

enum UI_MODE {
  NORNAL = 'NORMAL',
  DIALING = 'DIALING'
}

@Component({
  selector: 'agent-page',
  templateUrl: 'agent-page.component.html',
  styleUrls: ['./agent-page.component.scss']
})
export class AgentPageComponent extends FlexBasePage implements AfterViewChecked {
  @ViewChild('keypad') private readonly keypad: KeypadComponent;
  @ViewChild('agentPanel') private readonly agentPanel: AgentPanelComponent;

  isElectron: boolean;
  differ: any;
  userDisplayName: string;
  userTypeName: string;
  session_info: any = {};
  inOutState = '';
  pause_reasons: any;
  agent: AgentEntity;
  isAgent: boolean;
  uiMode: UI_MODE = UI_MODE.NORNAL;
  user: UserEntity;

  constructor(
    public messageService: MessageService,
    public authService: AuthenticationService,
    private readonly agentService: AgentService,
    private readonly agentPanelService: AgentPanelService,
    public phoneService: PhoneService,
    public dialogService: DialogService,
    private readonly bottomSheet: MatBottomSheet,
    platform: Platform,
    cdr: ChangeDetectorRef
  ) {
    super(cdr);

    this.isElectron = platform.isElectronApp();
    this.agentPanelService.enableAutoReload(1000);
    this.userDisplayName = this.authService.getUserDisplayName();

    this.authService.getUserType().then(userTypeName => {
      this.userTypeName = userTypeName;
    });

    this.isAgent = this.authService.isAgent();
  }

  @HostListener('click', ['$event'])
  handleMouseClickEvent(event: MouseEvent): void {
    const srcElement = event.srcElement as HTMLElement;
    const tagName = srcElement.tagName && srcElement.tagName.toLowerCase();
    if (tagName && ['input', 'textarea'].indexOf(tagName) >= 0) {
      return;
    }
    if (this.keypad) {
      return this.keypad.focus();
    }
  }

  @HostListener('keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    const srcElement = event.srcElement as HTMLElement;
    const tagName = srcElement.tagName && srcElement.tagName.toLowerCase();
    if (tagName && ['input', 'textarea'].indexOf(tagName) >= 0) {
      return;
    }
    return this.keypad.handleKeyboardEvent(event);
  }

  isDialing(): boolean {
    return (this.uiMode === UI_MODE.DIALING) || (!!this.phoneService.getDialingNumber());
  }

  canMakeCall(): boolean {
    return this.phoneService.canMakeCall();
  }

  phoneEngineReady(): boolean {
    return this.phoneService.isReady();
  }

  showContactBlock(): boolean {
    return false;
  }

  get ccConnected(): boolean {
    const status: MyCallCenterStatus = this.agentService.getMyCallcenterStatus();

    return status && status.is_online_cc;
  }

  keypadHidden(): boolean {
    return this.phoneService.hasCall() && (this.uiMode !== UI_MODE.DIALING);
  }

  ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  get connection_status(): MyCallCenterStatus {
    return MyCallCenterStatusRepository.getInstance<MyCallCenterStatusRepository>().getMyStatus();
  }

  isPaused(): boolean {
    const status: MyCallCenterStatus = this.connection_status;
    if (!status) {
      return false;
    }
    if (status.is_paused) {
      return true;
    }

    return false;
  }

  unpause(): Promise<any> {
    return this.agentPanel.unpause();
  }

  connectCallCenter(): Promise<any> {
    if (this.agentPanel) {
      return this.agentPanel.connectCallCenter();
    }
  }

  openDialogPause(): void {
    const pauseReason = this.connection_status ? this.connection_status.pause_reason : undefined;
    this.dialogService.openDialog2(PauseAgentDialog, { data: { pauseReason } }, async (data: { pause_reason_id: number }) => {
      if (!data || !data.pause_reason_id) {
        return;
      }

      const reason_id = data.pause_reason_id;
      try {
        await this.agentService.agentChangePauseReason(this.authService.getAgentId(), reason_id);
        this.successToast(_ti('agent_panel.message.change_pause_reason_success'));
      } catch (response) {
        this.loggerService.error('Change agent pause reason error', response);
        this.toastService.showErrorMessage(response, _ti('agent_panel.message.change_pause_reason_failure'));
      }
    });
  }

  changeVolumn(): void {
    this.bottomSheet.open(BottomSheetChangeVolume);
  }
}
